import service from "@/store/services/inspection-form-sections-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  inspectionFormSection: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, inspectionFormSection) => {
    state.inspectionFormSection = inspectionFormSection;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((inspectionFormSection) => {
      commit("SET_RESOURCE", inspectionFormSection);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((inspectionFormSection) => {
      commit("SET_RESOURCE", inspectionFormSection);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((inspectionFormSection) => {
      commit("SET_RESOURCE", inspectionFormSection);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  inspectionFormSection: (state) => state.inspectionFormSection,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((inspectionFormSection) => ({
      id: inspectionFormSection.id,
      name: inspectionFormSection.name,
    }));
  },
};

const inspectionForms = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default inspectionForms;
